import { useEffect, useState } from "react";
import { useLanguageContext } from "../../../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../../../Context/GlobalSpinnerContext";
import tabsStore from "../../../../Stores/TabsStore";
import tabsActions from "../../../../Actions/TabsActions";
import tabsConstants from "../../../../Constants/TabsConstants";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
export default function OrderImageButton(props) {
  const { item, anlageid } = props;

  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);
  const [inspectionImage, setInspectionImage] = useState([]);
  const [imagesSrc, setImagesSrc] = useState([]);
  const [noImage, setNoImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  function handleLightBox(e, _value) {
    e.preventDefault();
    setSelectedImage(_value);
    setIsLightBoxVisible(true);
  }

  useEffect(() => {
    let image = [];
    if (inspectionImage.length > 0) {
      inspectionImage.map((item) => {
        image.push({ url: `data:image/jpg;base64,${item.documentAsString}` });
      });
      setImagesSrc(image);
    }
  }, [inspectionImage]);

  useEffect(() => {
    function getInspectionImageSuccess() {
      const res = tabsStore.getInspectionImageResult();

      if (res.length > 0) {
        setInspectionImage(res);
      } else {
        setInspectionImage([]);
        setNoImage(true);
      }

      setGlobalSpinner(false);
    }
    function getInspectionImageFailure() {
      setGlobalSpinner(false);
    }
    tabsStore.addChangeListener(
      tabsConstants.GET_INSPECTION_IMAGE_SUCCESS,
      getInspectionImageSuccess,
    );
    tabsStore.addChangeListener(
      tabsConstants.GET_INSPECTION_IMAGE_FAILURE,
      getInspectionImageFailure,
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_INSPECTION_IMAGE_SUCCESS,
        getInspectionImageSuccess,
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_INSPECTION_IMAGE_FAILURE,
        getInspectionImageFailure,
      );
    };
  }, []);

  function handleLightBoxClose() {
    setIsLightBoxVisible(false);
  }

  useEffect(() => {
    if (isLightBoxVisible) {
      const elem = document.getElementsByClassName("lb-header")[0];
      const rl = elem.getElementsByClassName("rotatel");
      const rR = elem.getElementsByClassName("rotater");
      const zIn = elem.getElementsByClassName("zoomin");
      const zOut = elem.getElementsByClassName("zoomout");
      const close = elem.getElementsByClassName("close");

      rl[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.rotateLeft;
      });
      rR[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.rotateRight;
      });
      zIn[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.zoomIn;
      });

      zOut[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.zoomOut;
      });
      close[0].addEventListener("mouseenter", (event) => {
        event.target.title = localization.close;
      });

      if (inspectionImage.length > 1) {
        const prev = elem.getElementsByClassName("prev");
        const next = elem.getElementsByClassName("next");
        prev[0].addEventListener("mouseenter", (event) => {
          event.target.title = localization.previous;
        });
        next[0].addEventListener("mouseenter", (event) => {
          event.target.title = localization.nextImage;
        });
      }
    }
  }, [isLightBoxVisible]);

  return item !== null && item !== undefined ? (
    <>
      {" "}
      <Button
        variant="contained"
        className="gridTableButton gridTableButtonStyle"
        style={{ marginLeft: 8 }}
        onClick={(e) => {
          e.preventDefault();
          setGlobalSpinner(true);
          tabsActions.getInspectionImage(item);
        }}
        endIcon={<EastIcon />}
      >
        {localization.fetchImage}
      </Button>
      <div className="row ml-0 mt-2">
        {imagesSrc.map((item, index) => {
          return (
            <div className="col-2 mt-3 d-block  text-align-center" key={index}>
              <img
                className="imageDiv cursorPoint"
                alt="not Found"
                src={item.url}
                onClick={(e) => handleLightBox(e, index)}
              />
            </div>
          );
        })}
      </div>
      {noImage && (
        <div className="row ml-0 mt-3 mb-3 text-center">
          <div className="col">{localization.noImageAvailable}</div>
        </div>
      )}
      {isLightBoxVisible &&
        (inspectionImage.length == 1 ? (
          <Lightbox
            allowReset={false}
            onClose={handleLightBoxClose}
            image={imagesSrc[0].url}
          ></Lightbox>
        ) : (
          <Lightbox
            allowReset={false}
            onClose={handleLightBoxClose}
            images={imagesSrc}
            startIndex={selectedImage}
          ></Lightbox>
        ))}
    </>
  ) : null;
}
